import React from 'react';
import { Typography } from '../../components/typography';
import { useTranslation } from '../../hooks';

interface AIDisclaimerProps {
  showIcon?: boolean;
  justifyContent?: string;
  sx?: any;
}

export const AIDisclaimer = ({ showIcon = true, justifyContent = 'center', sx = {} }: AIDisclaimerProps = {}) => {
  const { t } = useTranslation();
  
  return (
    <Typography type="s5" align="center" sx={{ color: 'var(--text-secondary, #9ca3af)', fontSize: '10px !important', mt: 2, display: 'flex', alignItems: 'center', justifyContent, gap: '8px', ...sx }}>
      {showIcon && (
        <svg className="ai-disclaimer-icon" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14, flexShrink: 0, fill: 'none', color: 'currentColor', display: 'block' }}>
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      )}
      <span style={{ flex: 1, maxWidth: 'calc(100% - 20px)' }}>{t("common.ai_disclaimer")}</span>
    </Typography>
  );
};

export default AIDisclaimer;
